import { Pipe, PipeTransform } from '@angular/core';
import { SalesTeamLightModel } from '../../../../../shared/store/sales-team/types';

@Pipe({
    name: 'salesTeamExtractName',
    standalone: false
})
export class SalesTeamExtractNamePipe implements PipeTransform {
  transform(values: SalesTeamLightModel[] | null | undefined): string[] {
    if (!values || values.length == 0) return [''];

    return values.map((value) => value.name).sort();
  }
}
